export const useMediaStore = defineStore('plugin:media', () =>
{
    const breakpoints = {
        xs: 0,
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200,
        xxl: 1400
    };
    const width = ref(0);
    const mq = computed(() =>
    {
        return Object.entries(breakpoints)
            .filter(([, point]) => width.value >= point)
            .toSorted(([, a], [, b]) => b - a)
            .map(([key]) => key)
            .at(0) || 'xs';
    });
    const phone = computed(() => ['xs', 'sm'].includes(mq.value));
    const tablet = computed(() => ['md', 'lg'].includes(mq.value));
    const mobile = computed(() => ['xs', 'sm', 'md', 'lg'].includes(mq.value));
    const laptop = computed(() => ['xl'].includes(mq.value));
    const desktop = computed(() => ['xl', 'xxl'].includes(mq.value));

    function setWidth(value: number)
    {
        width.value = value;
    }

    return { width, mq, phone, tablet, mobile, laptop, desktop, setWidth };
});
